import styled from '@emotion/styled';

const ChipButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 0.25rem;
`;

export default ChipButtonContainer;
